module.exports = __webpack_public_path__ + "static/img/banner3.3d5c61e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.png
// module id = XMCP
// module chunks = 0